import React from 'react'
import { t } from 'ttag'
import Script from 'react-load-script'

class Share extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div>
        <p>{t`Use the links below to share this item on your social media accounts.`}</p>
        <div className="addthis_sharing_toolbox"></div>
        <Script
          url="//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5213ef406c962ebc"
          onError={this.handleScriptError.bind(this)}
          onLoad={this.handleScriptLoad.bind(this)}
        />
      </div>
    )
  }

  handleScriptError() {
    //noop, addthis often leads to errors when social is blocked by a school
  }

  handleScriptLoad() {
    window?.addthis?.layers?.refresh?.()
  }
}

export default Share
